import React from 'react';

class Cost extends React.Component {
    render() {
        return (
            <section className="cost" id="price">
                <h2 className="cost__title">Стоимость</h2>
            </section>
        )
    }
}

export default Cost;


// WEBPACK FOOTER //
// ./src/Components/DialerExpress/Cost.js